import {useParams } from "react-router";
import UserItemComponent from "../../components/Users/UserItem";


function UserItem(){
    const params = useParams();
    return (
        params.userId?
            <div>
            <UserItemComponent userId={params.userId} />   
            </div>
        :null
    )
}

export default UserItem;